import ApiClient from './ApiClient';

class EventsClient {
  constructor(authToken) {
    this.apiClient = new ApiClient();
    this.gatewayUri = 'api';
    this.latestVersion = 'v1';
    this.baseUri = process.env.VUE_APP_HACKATHON_SERVICE_URI;
    this.headers = {
      Authorization: `Bearer ${authToken}`,
    };
    this.params = {};
  }

  getEvent(eventId) {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/${this.latestVersion}/events/${eventId}`, this.params, this.headers)
      .then((response) => response.data);
  }

  getSchedule(eventId) {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/${this.latestVersion}/events/${eventId}/schedule`, this.params, this.headers)
      .then((response) => response.data);
  }

  getEvents() {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/${this.latestVersion}/events`, this.params, this.headers)
      .then((response) => response.data);
  }

  getEventResults(eventId) {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/${this.latestVersion}/events/${eventId}/results`, this.params, this.headers)
      .then((response) => response.data);
  }

  createEvent(name, admin, begins, ends) {
    const payload = {
      name, admin, begins, ends,
    };
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/${this.latestVersion}/events`, payload, this.headers)
      .then((response) => response.headers.location);
  }
}
export default EventsClient;
